module.exports = __webpack_public_path__ + "static/momentum-leader-winter-2022-c66601ee14d11cbefadd464af16e7531.svg";